import styled from "styled-components";

const SkewBg = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  min-height: 500px;
  background: ${(props) =>
    props.theme === "dark"
      ? "rgb(35,35,35)"
      : "linear-gradient(134deg,rgb(106, 152, 240) 0%, rgb(73, 97, 220) 99%)"};
  transform: skewY(-3deg);
  pointer-events: none;
  z-index: 2;
  @media screen and (max-width: 768px) {
    width: unset;
    height: 90%;
    top: 100px;
    left: -16px;
    right: -16px;
    bottom: 0;
  }
`;

export default SkewBg;
